// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dhypiwsqrefcmfckkbej.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRoeXBpd3NxcmVmY21mY2trYmVqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NTU5MDUsImV4cCI6MjA4ODAzMTkwNX0.9EUSUATdeB4E5SK6DElhqlMC-E9F6GLo9PCWvG55WbU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});